import Faq from '../Faq';

export default class SiteFaq extends Faq {
    isHidden: boolean = false;
}
